
export const VALIDATE_TOKEN = 'VALIDATE_TOKEN'



// WEBPACK FOOTER //
// ./src/pages/auth/constants.ts